<template>
    <div class="my_model">
        <div class="model_container">
            <el-table
                :key="tableKey"
                :data="userModelList"
                :header-cell-style="tableHeaderStyle"
                :cell-style="setCellStyle"
                :row-class-name="tableRowClassName"
                style="width: 100%">
                <el-table-column prop="name" label="模型名称" :show-overflow-tooltip="true" >
                    <template slot-scope="scope">
                        <span style="color: #606060; font-size: 1.09rem;">{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="thumbnail" label="缩略图" >
                    <template slot-scope="scope">
                        <img :src="scope.row.thumbnail" style="border-radius: 0.3rem; width: 5.25rem; height: 4.94rem; cursor: pointer;"  @click="goModelDetail(scope.row)">
                    </template>
                </el-table-column>
                <el-table-column prop="displaySize" label="大小" >
                    <template slot-scope="scope">
                        <span style="color: #999999; font-size: 0.85rem;">{{ scope.row.displaySize }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="modelFormat" label="格式" >
                    <template slot-scope="scope">
                        <span style="color: #999999; font-size: 0.85rem;">{{ scope.row.modelFormat }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="modelDimension" label="尺寸(m³)" >
                    <template slot-scope="scope">
                        <span style="color: #999999; font-size: 0.85rem;">{{ scope.row.modelLong }} * {{ scope.row.modelWide }} * {{ scope.row.modelHeight}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="operate" label="操作" >
                    <template slot-scope="scope">
                        <div class="operate_inner">
                            <div class="img_container">
                                <img src= "../../../assets/image/资源 35.png" title="转发"
                                 @click="shareModel(scope.row.id, scope.row.share, scope.row.modelType)"
                                 style="width: 1rem; height: 1rem; cursor: pointer; margin-right: 7%;">
                            </div>
                            <el-button @click="cancelSubModel(scope.row)">
                                {{ scope.row.collected ? '取消收藏' : '收藏' }}
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="model_page">
                <el-pagination
                    background
                    :current-page="currentElPage"
                    :total="total"
                    :page-size="size"
                    @current-change="currentChange"
                    :hide-on-single-page="value"
                    layout="prev, pager, next"
                    @size-change="handleSizeChange"
                >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import ModelShowList from '../../../components/modelShowList/index.vue'
import { getUserCollectUserModel, changeCollectState, cancelUserCollectUserModel, getUserCollect, getModelById } from '../../../util/index'
export default {
    data() {
        return {
            total:0,
            total1:0,
            total2:0,
            showShare: false,
            userModelList:[],
            userModelLists:[],
            totalModels:0,
            totalPages: 0,
            value: false,  //隐藏分页
            currentElPage: 1,  //当前页
            size: 10,  //每页显示条数
            tableKey: 0,
        }
    },
    methods:{
        tableRowClassName(row, rowIndex){
            if ((row.rowIndex+1) % 2 === 1){
                return 'deep'
            }else if((row.rowIndex+1) % 2 === 0){
                return 'shallow'
            }
        },
        // 表格头部圆角
        tableHeaderStyle({row, column, rowIndex, columnIndex}){
            let extra = {}
            if (rowIndex === 0 && columnIndex === 0) {
                extra = {
                    'background-color':'red',
                    'border-radius':'0.56rem 0 0 0.56rem'
                }
            } else if(rowIndex === 0 && columnIndex === 5){
                extra = {
                    'background-color':'red',
                    'border-radius':'0 0.56rem 0.56rem 0'
                }
            }
            const styleResult = Object.assign({}, extra, {
                'background-color':'#C9C9C9',
            })
            return styleResult
        },
        // 表格内容圆角
        setCellStyle({row, column, rowIndex, columnIndex}){
            let extra = {}
            if (columnIndex === 0){
                extra = {
                    'border-radius':'0.56rem 0 0 0.56rem'
                }
            } else if(columnIndex === 5){
                extra = {
                    'border-radius':'0 0.56rem 0.56rem 0'
                }
            }
            const styleResult = Object.assign({}, extra, {
                
            })
            return styleResult
        },
        currentChange(page){
            this.currentElPage = page
            this.getUserModels()
        },
        handleSizeChange(val){
            this.size = val
            this.getUserModels()
        },
        prevClick(){
            if(this.currentElPage == 1 ){
                return
            }
            this.currentElPage--
            this.userModelList = this.userModelLists.slice((this.currentElPage-1)*5,this.currentElPage*5)
            // this.industrialModel = industrialModels.slice(8, 16)
        },
        nextClick(){
            // 向上取整
            let total = Math.ceil(this.totalModels/5)
            if(this.currentElPage === total || this.currentElPage > total){
                return
            }
            this.currentElPage++
            this.userModelList = this.userModelLists.slice((this.currentElPage-1)*5,this.currentElPage*5)
            // this.industrialModel = industrialModels.slice(0, 8)
        },
        cancelSubModel(row){
            let token = window.localStorage.getItem('userToken')
            this.tableKey = Math.random()
            // 遍历整个数组，将对应的collected变成相反
            row.collected = !row.collected;
            let obj = {
                isFavorite: row.collected
            }
            if(row.share){
                obj.shareKey = row.share
            }
            changeCollectState(row.id, obj, token).then((res) => {
                if(res.code === 200){
                    if(!row.collected){
                        this.$message.success('已取消收藏')
                    }else{
                        this.$message.success('已收藏')
                    }
                    // this.getUserCollectUserModel()
                    // this.getUserModels()
                    // this.total = res.data.total
                    // this.currentElPage = 1
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        shareModel(id, key, type){
            // console.log(id, key, type);
            let url = 'http://pongo.net.cn/models_detail?'
            if(key){
                url += 'key=' + key
            }else{
                url += 'id=' + id
            }
            if (navigator.clipboard && window.isSecureContext) {
                // navigator clipboard 向剪贴板写文本
                navigator.clipboard.writeText(url).then(() => {
                    this.$message.success('已复制到剪切板')
                });
            } else {
                // 创建text area
                let textArea = document.createElement("textarea");
                textArea.value = url;
                // 使text area不在viewport，同时设置不可见
                textArea.style.position = "absolute";
                textArea.style.opacity = 0;
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                return new Promise((res, rej) => {
                    // 执行复制命令并移除文本框
                    document.execCommand('copy') ? res() : rej();
                    textArea.remove();
                    this.$message.success('已复制到剪切板')
                });
            }
        },
        // 跳转模型详情页
        goModelDetail(obj){
            let token = window.localStorage.getItem('userToken')
            getModelById(obj.id, token)
            if(obj.share){
                this.$router.push({
                    path:'/models_detail',
                    query:{
                        key:obj.share,
                    }
                })
                return
            }
            this.$router.push({
                path:'/models_detail',
                query:{
                    id:obj.id,
                }
            })
        },
        // 获取用户收藏的模型
        getUserModels(){
            let obj = {
                current: this.currentElPage,
                size: this.size,
            }
            let token = window.localStorage.getItem('userToken')
            getUserCollect(obj, token).then(res => {
                if(res.code === 200){
                    // this.userModelList.concat(res.data.list)
                    // console.log(this.userModelList);
                    this.userModelList = res.data.records
                    // 每个里面push一个collected属性，值为true
                    this.userModelList.forEach((item, index) => {
                        item.collected = true
                    })
                    this.total = res.data.total
                    this.currentElPage = res.data.current
                } else {
                    this.$message({message: res.message, type: 'error'})
                }
            })
            // getUserCollectNormalModel(obj).then(res => {
            //     if(res.code === '0'){
            //         // this.userModelList = res.data.list
            //         // console.log(res.data.list);
            //         // console.log(this.userModelList);
            //         let newList = res.data.list
            //         let newList2 = [...this.userModelList, ...newList]
            //         this.userModelLists = newList2
            //         this.userModelLists.forEach((item, index) => {
            //             item.order = index + 1
            //             // 新增modelDimension属性
            //             item.modelDimension = item.modelLong + '*' + item.modelWide + '*' + item.modelHeight
            //         })
            //         this.userModelList = this.userModelLists.slice(0, 5)
            //         this.total2 = Number(res.data.total)
            //         this.total = this.total1 + this.total2
            //         this.totalPages = Math.ceil(this.total / 5)
            //         // this.userModelList.concat(newList)
            //     } else if (res.code == '-1'){
            //         this.$message.error(res.message)
            //         this.$router.push('/')
            //         this.$bus.$emit('openLogin', false)
            //     }
            //     else {
            //         this.$message.error(res.message)
            //     }
            // })
        }
    },
    components: {
        ModelShowList
    },
    created() {
        this.getUserModels()
        
    }
}
</script>

<style scoped lang="less">
::v-deep .el-table td.el-table__cell div{
    display: flex;
    justify-content: center;
}
::v-deep .el-table .cell{
    text-align: center;
}
::v-deep .el-table .deep{
    background-color: #F9F9F9;
    border-radius: 10px;
}
::v-deep .el-table .shallow{
    background-color: #f4f4f4;
    border-radius: 10px;

}
::v-deep .el-table__header-wrapper,
::v-deep .el-table__body-wrapper{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 94%;
    margin: 0 auto;
}
::v-deep .el-table__header{
    width: auto !important;
}
::v-deep .el-table__body{
    width: auto !important;
//   -webkit-border-horizontal-spacing: 13px;  // 水平间距
  -webkit-border-vertical-spacing: 6px;  // 垂直间距
}
::v-deep .el-table::before{
    display: none;
}
::v-deep .el-table th.el-table__cell{
    background-color: #C9C9C9;
}
// ::v-deep .el-table_1_column_1{
//     border-top-left-radius: 10px;
//     border-bottom-left-radius: 10px;
// }
// ::v-deep .el-table_1_column_7{
//     border-top-right-radius: 10px;
//     border-bottom-right-radius: 10px;
// }
::v-deep .el-table th.el-table__cell>.cell{
    font-size: 0.85rem;
    font-weight: normal;
    color: #666666;
}
.my_model{
    // background-color: rgb(255, 255, 255);
    border-radius: 0.56rem;
    .model_container{
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 2.69rem 0;
        // height: 90px;
        i{
            font-size: 1.5rem;
            cursor: pointer;
        }
        i:hover{
            color: #54ceec;
        }
        .title{
            background-color: aqua;
            width: 90%;
            height: 100%;
            margin: 0 auto;
        }
        .operate_inner{
            display: flex; 
            align-items: center;
            .img_container{
                width: 1.31rem;
                height: 1.31rem;
                padding: 0.8rem;
                background-color: #C9C9C9;
                border-radius: 90%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 0.6rem;
            }
            .img_container:hover{
                cursor: pointer;
                background-color: #54ceec;
            }
            ::v-deep .el-button{
                background-color: #cccccc;
                border-radius: 20px;
                padding: 7px 20px;
                color: #fff;
            }
            ::v-deep .el-button:hover{
                background-color: #54ceec;
                color: #fff;
            }
        }
    }
    .model_page{
        // margin: 0 auto;
        display: flex;
        justify-content: center;
        padding: 2rem 0;
        // background-color: #54ceec;
    }
}
</style>